/* tslint:disable */
/* eslint-disable */
/**
 * SONeu.WebApi | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { JsonNode } from './JsonNode';
import {
    JsonNodeFromJSON,
    JsonNodeFromJSONTyped,
    JsonNodeToJSON,
    JsonNodeToJSONTyped,
} from './JsonNode';

/**
 * 
 * @export
 * @interface UpdateSystemSettingRequest
 */
export interface UpdateSystemSettingRequest {
    /**
     * 
     * @type {JsonNode}
     * @memberof UpdateSystemSettingRequest
     */
    value: JsonNode | null;
}

/**
 * Check if a given object implements the UpdateSystemSettingRequest interface.
 */
export function instanceOfUpdateSystemSettingRequest(value: object): value is UpdateSystemSettingRequest {
    if (!('value' in value) || value['value'] === undefined) return false;
    return true;
}

export function UpdateSystemSettingRequestFromJSON(json: any): UpdateSystemSettingRequest {
    return UpdateSystemSettingRequestFromJSONTyped(json, false);
}

export function UpdateSystemSettingRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateSystemSettingRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'value': JsonNodeFromJSON(json['value']),
    };
}

export function UpdateSystemSettingRequestToJSON(json: any): UpdateSystemSettingRequest {
    return UpdateSystemSettingRequestToJSONTyped(json, false);
}

export function UpdateSystemSettingRequestToJSONTyped(value?: UpdateSystemSettingRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'value': JsonNodeToJSON(value['value']),
    };
}

